export interface FormProps {
  submit: string;
  checkBox: CheckBox[];
  fieldSets: FieldSet[];
}

export interface CheckBox {
  label: string;
  name: string;
}

export const NAMES = {
  formReporterName: 'formReporterName',
  formReporterStatus: 'formReporterStatus',
  formReporterPhone: 'formReporterPhone',
  formReporterEmail: 'formReporterEmail',
  formPatientName: 'formPatientName',
  formPatientAge: 'formPatientAge',
  formPatientGender: 'formPatientGender',
  formDrugName: 'formDrugName',
  formDrugManufacturer: 'formDrugManufacturer',
  formDrugMedicalForm: 'formDrugMedicalForm',
  formDrugSerial: 'formDrugSerial',
  formReviewMessage: 'formReviewMessage',
  formConfirm: 'formConfirm',
};

export type Name = keyof typeof NAMES;

export interface Field {
  label: string;
  type: string;
  required?: boolean;
  name: Name;
  placeholder: string;
}

export interface FieldSet {
  title: string;
  fields: Field[];
}

export interface IFormData {
  formReporterName: string;
  formReporterStatus: string;
  formReporterPhone: string;
  formReporterEmail: string;
  formPatientName: string;
  formPatientAge: string;
  formPatientGender: string;
  formDrugName: string;
  formDrugManufacturer: string;
  formDrugMedicalForm: string;
  formDrugSerial: string;
  formReviewMessage: string;
  formConfirm: boolean;
}
